import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios, { getActiveAuth, clearActiveAuth } from "../api/axios";

export default function ProtectedRoute({ children, role }) {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const { token, role: storedRole, userId: storedUserId } = getActiveAuth();
  const userRole = storedRole?.toUpperCase();

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        setIsValidating(false);
        setIsValid(false);
        return;
      }

      try {
        const response = await axios.get("/auth/verify");

        if (response.status === 200) {
          const data = response.data;
          // Ensure tenant ID is locked in sessionStorage
          if (data?.id) {
            if (storedUserId && String(storedUserId) !== String(data.id)) {
              console.warn("Tenant mismatch detected. Expected:", storedUserId, "Got:", data.id);
              clearActiveAuth();
              setIsValid(false);
              return;
            }
            sessionStorage.setItem("userId", String(data.id));
            localStorage.setItem("userId", String(data.id));
          }

          if (role && data.role?.toUpperCase() !== role.toUpperCase()) {
            console.warn("Role mismatch. Expected:", role, "Got:", data.role);
            setIsValid(false);
          } else {
            setIsValid(true);
          }
        } else {
          clearActiveAuth();
          setIsValid(false);
        }
      } catch (error) {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          clearActiveAuth();
          setIsValid(false);
        } else if (token && (!role || userRole === role)) {
          setIsValid(true);
        } else {
          setIsValid(false);
        }
      } finally {
        setIsValidating(false);
      }
    };

    const timer = setTimeout(validateToken, 100);
    return () => clearTimeout(timer);
  }, [token, role, userRole, storedUserId]);

  if (isValidating) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isValid || !token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
